import { GenericResponseCode, type GenericResponseResult } from './bs-api.service';

/**
 * Error thrown when an API returns HTTP 200 but {@link GenericResponseResult.result.code} is not
 * {@link GenericResponseCode.SERVICE_OK}.
 */
export class ApiServiceError extends Error {
  constructor(
    message: string,
    readonly response: GenericResponseResult,
  ) {
    super(message);
    this.name = 'ApiServiceError';
  }
}

/**
 * Validates {@link GenericResponseResult.result.code}. Throws {@link ApiServiceError} when the code is not
 * {@link GenericResponseCode.SERVICE_OK}. Use inside RxJS `map()` so `subscribe({ error })` handles business failures.
 */
export function assertServiceOk(response: GenericResponseResult): void {
  const code = response?.result?.code;
  if (code === GenericResponseCode.SERVICE_OK) {
    return;
  }

  const message = response?.result?.message?.trim();
  throw new ApiServiceError(message || code || GenericResponseCode.SERVICE_ERROR, response);
}
